import { createTheme } from "@mui/material";
import { grey, blueGrey, green, red, amber } from "@mui/material/colors";

import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";


let theme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#6C5CE7',
            light: '#8e7ff0',
            dark: '#4b3cc7',
            contrastText: '#ffffff',
            normal: '#6C5CE7'
        },
        secondary: {
            main: '#E84393',
            light: '#f06fb0',
            dark: '#c12f74',
            contrastText: '#330014'
        },
        success: {
            main: green[500]
        },
        warning: {
            main: amber[500]
        },
        error: {
            main: red[500]
        },
        background: {
            default: '#f8fafc',
            paper: '#ffffff'
        },
        text: {
            primary: blueGrey[900],
            secondary: blueGrey[600]
        },
        neutral: {
            light: grey[50],
            medium: grey[300],
            normal: grey[700],
            main: grey[900]
        },
        green: { main: '#22c55e' },
        red: { main: '#f87171' },
        yellow: { main: '#fde047' },
        brand: {
            violet: '#6C5CE7',
            pink: '#E84393'
        },
        gradient: {
            primary: 'linear-gradient(135deg, #6C5CE7 0%, #E84393 100%)',
            primaryLight: 'linear-gradient(135deg, #8e84e8ff 0%, #f1c1d8ff 100%)',
            surface: 'linear-gradient(180deg, #f8fafc 0%, #eef2ff 60%, #ffffff 100%)',
            light: 'linear-gradient(135deg, #6C5CE7 0%,#eef2ff 60%, #E84393 100%)'
        }
    },
    shape: {
        borderRadius: 8
    },
    typography: {
        fontFamily: ['Inter', 'sans-serif'].join(','),
        h1: { fontWeight: 800 },
        h2: { fontWeight: 800 },
        h3: { fontWeight: 700 },
        h4: { fontWeight: 700 },
        h5: { fontWeight: 700 },
        h6: { fontWeight: 700 },
        button: { textTransform: 'none', fontWeight: 600 }
    },
    shadows: [
        'none',
        '0px 2px 8px rgba(2,6,23,0.06)',
        '0px 4px 12px rgba(2,6,23,0.08)',
        '0px 8px 24px rgba(2,6,23,0.10)',
        ...Array(22).fill('0px 8px 24px rgba(2,6,23,0.10)')
    ]
})

theme = createTheme(theme, {
    typography: {
        link: {
            fontSize: '0.8rem',
            [theme.breakpoints.up('md')]: {
                fontSize: '0.9rem'
            },
            fontWeight: 500,
            color: theme.palette.primary.normal,
            display: 'block',
            cursor: 'pointer'
        },
        cardTitle: {
            fontSize: '1.2rem',
            display: 'block',
            fontWeight:500
        },
        h6: {
            fontSize: '1rem'
        },
        h7: {
            fontSize: '0.8rem'
        },
        h8: {
            fontSize: '0.7rem'
        },
        eyebrow: {
            fontSize: '0.75rem',
            letterSpacing: 1.1,
            textTransform: 'uppercase',
            color: theme.palette.text.secondary
        }
    },
    components: {
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    border: '1px solid',
                    borderColor: theme.palette.divider,
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    "&.Mui-disabled": {
                        backgroundColor: grey[300],    // bg for disabled
                        color: grey[600],              // text color for disabled
                        boxShadow: "none",
                        opacity: 0.7,
                    },
                },
                containedPrimary: {
                    backgroundImage: theme.palette.gradient.primary,
                    "&.Mui-disabled": {
                        backgroundImage: "none",
                        backgroundColor: grey[300],
                        color: grey[600],
                    }
                }
            }
        },
        MuiAppBar: {
            styleOverrides: {
                colorPrimary: {
                    backgroundImage: theme.palette.gradient.primary
                }
            }
        }
    }
});

export default theme
